import DirectoryPage from '@/components/Directory';
import { DIRECTORY_COPY, buildDirectoryPath, createDirectoryGetServerSideProps } from '@/utils/directoryPage.utils';
import type { InferGetServerSidePropsType, NextPage } from 'next';
import { NextSeo } from 'next-seo';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const { title, description } = DIRECTORY_COPY.regions;

const RegionsPage: NextPage<InferGetServerSidePropsType<typeof getServerSideProps>> = ({
  type,
  items,
  total,
  currentPage,
  totalPages,
  locale,
  searchTerm,
}) => {
  // Self-referencing canonical on every view, including page 2+ and filtered ones —
  // see buildDirectoryPath for why.
  const canonicalUrl = `${publicRuntimeConfig.origin}${buildDirectoryPath(type, {
    page: currentPage,
    locale,
    searchTerm,
  })}`;
  const metaTitle = `${title} | Parcel Monitor`;

  // ?page=N stays indexable, ?locale=X and ?q= do not — see buildDirectoryPath.
  const isFilteredView = !!locale || !!searchTerm;

  return (
    <>
      <NextSeo
        title={metaTitle}
        description={description}
        canonical={canonicalUrl}
        noindex={isFilteredView}
        openGraph={{
          url: canonicalUrl,
          title: metaTitle,
          description,
          images: [{ url: `${publicRuntimeConfig.origin}/images/parcel_monitor_og_image.png` }],
          type: 'website',
        }}
      />
      <DirectoryPage
        type={type}
        items={items}
        total={total}
        currentPage={currentPage}
        totalPages={totalPages}
        locale={locale ?? undefined}
        searchTerm={searchTerm ?? undefined}
      />
    </>
  );
};

export const getServerSideProps = createDirectoryGetServerSideProps('regions');

export default RegionsPage;
